// Local translations
export const T = {
  en_GB: {
    addTenant: "Add Tenant",
    searchPlaceholder: "Search tenants...",
    noSearchResults: "No tenants match your search.",
  },
  nb_NO: {
    addTenant: "Legg til organisasjon",
    searchPlaceholder: "Søk etter organisasjoner...",
    noSearchResults: "Ingen organisasjoner samsvarer med søket ditt.",
  },
} as const;
